<template>
  <div>
    <a-card type="inner" size="small">
      <a-skeleton :loading="loading" active>
        <a-table :columns="columns" :dataSource="items.data" rowKey="id" :pagination="pagination" @change="tableChanged">
          <h5 slot="created_at" slot-scope="record" class="text-center">
            {{ moment(record.created_at).format('DD/MM/YYYY HH:mm:ss') }}
          </h5>

          <h5 slot="sponsor_name" slot-scope="record">
            <a-icon type="bank" /> <strong> {{ record.sponsor_name }}</strong>
          </h5>

          <div slot="action" slot-scope="record">
            <template v-if="record.hash">
              <a-button size="small" type="primary" icon="edit" @click="() => edit(record)"  />
            </template>
          </div>
        </a-table>
      </a-skeleton>
    </a-card>

    <a-drawer :width="720" placement="right" :closable="true" :visible="editing !== null" @close="() => editing = null">
      <template v-if="editing !== null && ! viewOnly">
        <h-sponsor-form :sponsor="editing" @success="() => editing = null" />
      </template>
    </a-drawer>
  </div>
</template>

<script>
import pagination from "../../../config/pagination"

const sponsorColumns = [
  {
		key: 'created_at',
		title: 'Date Time',
		align: 'center',
		scopedSlots: {customRender: 'created_at'},
	}, {
		key: 'sponsor_name',
		title: 'Sponsor',
		scopedSlots: {customRender: 'sponsor_name'}
	}, {
		key: 'action',
		title: '',
		align: 'right',
		scopedSlots: {customRender: 'action'}
	}
]

export default {
  props: {
    path: {
      type: String,
      default: null
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    routeName: {
      type: String,
      default: 'hyperion.finances.sponsor'
    }
  },
  computed: {
    columns() {
      let columns = sponsorColumns

      if (this.viewOnly)
        delete columns['action']
      return columns
    },
    pagination() {
      return {
        current: this.items.current_page,
        total: this.items.total,
        pageSize: this.pageSize,
        showSizeChanger: true
      }
    },
    pageSize() {
      return parseInt(this.items.per_page)
    },
    pathUrl() {
      return this.path === null
        ? this.routeUri('hyperion.finances.sponsor')
        : this.path
    },
  },
  data: () => ({
    loading: false,
    form: {},
    items: pagination,
    filters: {
      q: '',
      page: 1
    },
    editing: null,
    deleting: []
  }),
  created() {
    this.getItems()
  },

  methods: {
    updateUrl(record) {
      return this.pathUrl + '/' + record.hash
    },
    getItems() {
      this.$emit('filtered', this.filters)
      this.loading = true
      this.$http.get(this.pathUrl, {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    onDeleteSuccess() {
      this.closeDrawer()
      this.$notification.success({
        message: 'Success',
        description: 'Data has been successfully deleted!',
        onClose: () => window.location.reload()
      })
    },
    filtered() {
      this.$emit('filtered', this.filters)
    },
    destroy(record) {
      this.deleting.push(record.hash)
      this.$http.delete(this.updateUrl(record))
        .then((r) => this.onDeleteSuccess())
        .catch((e) => this.handleXhrError(e));
    },
    edit(record) {
      this.editing = record
    }
  }
}
</script>
